module.exports = __webpack_public_path__ + "static/img/btn_bg.03119b36.png";